// extracted by mini-css-extract-plugin
module.exports = {"main__wrapper":"n_1 noScrollbar","canvas__wrapper":"n_2","children__wrapper":"n_3"};